import { takeEvery, put } from "redux-saga/effects";
import * as dynamicFormActionCreators from "../../components/DynamicForm/actionCreators";

export function* fetchUpdatedAddressCode(action) {
    yield put(
        dynamicFormActionCreators.setSelectedAddressAsync({
            value: action.payload,
            key: action.key,
            label: action.label,
        })
    );
}
export function* fetchselectAddressCode() {
    yield takeEvery("SELECTED_ADDRESS", fetchUpdatedAddressCode);
}
